import { render, staticRenderFns } from "./facebookDetails.vue?vue&type=template&id=7a5069e0&scoped=true"
import script from "./facebookDetails.vue?vue&type=script&lang=js"
export * from "./facebookDetails.vue?vue&type=script&lang=js"
import style0 from "./facebookDetails.vue?vue&type=style&index=0&id=7a5069e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5069e0",
  null
  
)

export default component.exports